// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1UlU4","ranges":"BmiRanges_ranges__153k-"};